export const ADD_SUBSCRIPTION_URL =
  'https://timesofindia.indiatimes.com/newsletter/addsubscription/';

export const Get_SUBSCRIPTION_URL =
  'https://timesofindia.indiatimes.com/newsletter/getsubscription/';

export const Get_UNSUBSCRIPTION_URL =
  'https://timesofindia.indiatimes.com/newsletter/unsubscribenlwithhash/';
export const ALREADY_SUBSCRIBED = `This email is already subscribed.`;
export const THANKS_SUBSCRIBING_MESSAGE = `Thank you for subscribing.`;
export const VALID_EMAIL_MESSAGE = `Please enter a valid email id`;
export const EXPIRY_DAYS = 2;
export const EXPIRY_KEY = `cv19subscribed`;
export const WDT_EXPIRY_KEY = `cv19wdttimestamp`;
export const POPUPClASS = `T10-popUp`;
export const WIDGETCLASS = `T10-widget`;
export const STICKYCLASS = `C19-sticky`;
export const LINKTOPTEN = `/timestopten.cms`;
export const LOGOIMAGE = `https://static.toiimg.com/photo/msid-68044600/68044600.jpg`;
export const TRANSITIONCLASS = `T10-showWithTransition`;
export const GA_CATEGORY = `covid19_newsletter`;
export const GA_ACTION_SUCCESS = `subscribe_success`;
export const GA_ACTION_INITIATED = `subscribe_initiated`;
